'use client'

import HeroBanner from '@/components/home/HeroBanner';
import RegisterSection from '@/components/home/RegisterSection';
import RegisterIntroSection from '@/components/home/RegisterIntroSection';
import WeekSection from '@/components/home/WeekSection';
import WeekVideoSection from '@/components/home/WeekVideoSection';
import TestimonialSection from '@/components/home/TestimonialSection';
import ParentSection from '@/components/home/ParentSection';
import ClubSection from '@/components/home/ClubSection';
import AffiliateSection from '@/components/home/AffiliateSection';
import RegisterButton from '@/components/home/RegisterButton';
import ScrollToHash from '@/components/ScrollToHash';
import { GiBackpack } from 'react-icons/gi';
import { useEffect, useState } from 'react';
import { getImageUrl, sendRequest } from '@/lib/api-service';


const CampSchedules = () => {
	const [sliderImages, setSliderImages] = useState<string[]>([]);
	const [weekImages, setWeekImages] = useState<string[]>([]);
	const [partners, setPartners] = useState<string[]>([]);

	const [slogan, setSlogan] = useState<string>('');
	const [callToAction, setCallToAction] = useState<string>('');
	const [weekIntro, setWeekIntro] = useState<string>('');
	// const [weekDays, setWeekDays] = useState<string[]>([]);

	const [parentHelp, setParentHelp] = useState<string>('');
	const [parentRules, setParentRules] = useState<string[]>([]);
	const [parentWarning, setParentWarning] = useState<string>('');

	
	useEffect(() => {
		const fetchHomepageImages = async () => {
			const response = await sendRequest('POST', '/front-images/', {}, true);
			if (response && Array.isArray(response)) {
				const slider: string[] = [];
				const week: string[] = [];
				const partnersArr: string[] = [];
				response.forEach((img: { code: string; thumbnail: string }) => {
					if (img.code.startsWith('slider')) {
						slider.push(getImageUrl(img.thumbnail));
					} else if (img.code.startsWith('week')) {
						week.push(getImageUrl(img.thumbnail));
					} else if (img.code.startsWith('partner')) {
						partnersArr.push(getImageUrl(img.thumbnail));
					}
				});
				setSliderImages(slider);
				setWeekImages(week);
				setPartners(partnersArr);
			}
		};
		const fetchTexts = async () => {
			const response = await sendRequest('POST', '/dynamic-texts/', {codes:["slogan", "call_to_action", "week_intro", "parent_help", "parent_rules", "parent_warning"]}, true);
			if (response && typeof response === 'object' && !Array.isArray(response)) {
				if ('slogan' in response) setSlogan(response.slogan);
				if ('call_to_action' in response) setCallToAction(response.call_to_action);
				if ('week_intro' in response) setWeekIntro(response.week_intro);
				if ('parent_help' in response) setParentHelp(response.parent_help);
				if ('parent_rules' in response) setParentRules(response.parent_rules ? response.parent_rules.split(',') : []);
				if ('parent_warning' in response) setParentWarning(response.parent_warning);
			}
		};
		fetchHomepageImages();
		fetchTexts();
	}, []);
  
	return (
		<div className='max-w-[1920px] mx-auto bg-white'>
			<ScrollToHash />
			<HeroBanner slogan={slogan}/>
			<RegisterButton/>
			<RegisterIntroSection sliderImages={sliderImages} callToAction={callToAction}/>
				<div
					className="w-full md:h-[200px] h-[100px] -mt-1 -mb-1 bg-no-repeat bg-top bg-cover"
					style={{ backgroundImage: "url('/waves/fromwhite1.svg')" }}
				/>
				<div className='relative bg-brandsky-900 pb-10 overflow-hidden'>
				<GiBackpack className="absolute bottom-[00px] right-[-80px] w-40 h-40 sm:w-64 sm:h-64 text-white opacity-10 pointer-events-none z-0" />
			<RegisterSection/>	
			</div>	
				<div
					className="w-full md:h-[200px] h-[100px] -mt-1 -mb-1 bg-no-repeat bg-top bg-cover"
					style={{ backgroundImage: "url('/waves/fromsky1.svg')" }}
				/>
			<WeekSection weekImages={weekImages} weekIntro={weekIntro}/>
				<div
					className="w-full md:h-[200px] h-[100px] -mt-1 -mb-1 bg-no-repeat bg-top bg-cover"
					style={{ backgroundImage: "url('/waves/fromwhite2.svg')" }}
				/>	
			<WeekVideoSection/>
				<div
					className="w-full md:h-[200px] h-[100px] -mt-1 -mb-1 bg-no-repeat bg-top bg-cover"
					style={{ backgroundImage: "url('/waves/fromsky2.svg')" }}
				/>
			<TestimonialSection/>
				<div
					className="w-full md:h-[200px] h-[100px] -mt-1 -mb-1 bg-no-repeat bg-top bg-cover"
					style={{ backgroundImage: "url('/waves/fromwhite3.svg')" }}
				/>
			<ParentSection parentHelp={parentHelp} parentRules={parentRules} parentWarning={parentWarning} />
				<div id='clubs'
					className="w-full md:h-[200px] h-[100px] -mt-1 -mb-1 bg-no-repeat bg-top bg-cover"
					style={{ backgroundImage: "url('/waves/fromsky3.svg')" }}
				/>
			<ClubSection/>

				<div id='partners'
					className="w-full md:h-[200px] h-[100px] -mt-1 -mb-1 bg-no-repeat bg-top bg-cover"
					style={{ backgroundImage: "url('/waves/fromwhite4.svg')" }}
				/>

			<AffiliateSection partners={partners}/>

		</div>
	);
};

export default CampSchedules;
